import Vue from 'vue'
import Vuex from 'vuex'

import cate from './modules/admin/cate'
import articel from './modules/admin/articel'
import team from './modules/admin/team'
import menu from './modules/admin/menu'
import adminManger from './modules/admin/adminManger'
import roles from './modules/admin/roles'
import permissions from './modules/admin/permissions'
import ad from './modules/admin/ad'
import user_detail from './modules/admin/user_detail'
import banner from './modules/admin/banner'
import articles from './modules/admin/articles'
import setting from './modules/admin/setting'
import dy_log from './modules/admin/dy_log'
import zip_job from './modules/admin/zip_job'
import zip_clash from './modules/admin/zip_clash'
import about from './modules/admin/about'
//import hook
import index from './modules/admin/index'
import table from './modules/code/table'
import tableCard from './modules/code/tableCard'
import storage from '@/lib/tool/storage'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogin: false,
    adminInfo:{},
  },
  mutations: {
    setLogin(state, isLogin) {
      state.isLogin = isLogin;
    },
    setAdminInfo(state, data) {
      state.adminInfo = data;
    }
  },
  action: {},
  modules: {
    index,
    table,
    tableCard,

    cate,
    articel,
    team,
    menu,
    adminManger,
    roles,
    permissions,
    ad,
    user_detail,
    banner,
    articles,
    setting,
    dy_log,
    zip_job,
    zip_clash,
    about,
//modules hook
    adminLogin: {
      state: {
        token_type: 'Bearer',
        expires_in: '',
        access_token: '',
        refresh_token: ''
      },
      mutations: {
        setToken(state, data) {
          state.token_type = data.token_type;
          state.expires_in = data.expires_in;
          state.access_token = data.access_token;
          state.refresh_token = data.refresh_token;

          storage.setItem({key: 'login.token_type', value: data.token_type});
          storage.setItem({key: 'login.expires_in', value: data.expires_in});
          storage.setItem({key: 'login.access_token', value: data.access_token});
          storage.setItem({key: 'login.refresh_token', value: data.refresh_token});
        },
      },
      actions: {
        logout(context) {
          context.commit('setToken', {
            token_type: null,
            expires_in: null,
            access_token: null,
            refresh_token: null,
          });
        },
        initAdmin(context) {
          return new Promise((success, faild) => {
            let data = {};
            data.token_type = storage.getItem({key: 'login.token_type'});
            data.expires_in = storage.getItem({key: 'login.expires_in'});
            data.access_token = storage.getItem({key: 'login.access_token'});
            data.refresh_token = storage.getItem({key: 'login.refresh_token'});
            context.commit('setToken', data);
            success();
          });

        }
      }
    }
  },
  getters: {
    getLoginStatus: state => {
      return state.adminLogin.access_token;
    }
  },

});



// WEBPACK FOOTER //
// ./src/vuex/index.js